
<template>
    <div>
        <el-dialog :title="title" :visible.sync="dialogrefuse">
            <el-form :model="form" ref="form" label-width="100px" class="demo-ruleForm">
                <el-form-item :label="title" prop="content"  :rules="[ { required: true, message: '请输入'+title, trigger: 'blur' }]" >
                    <el-input v-model="form.content"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitrefuse('form')">提交</el-button>
                    <el-button @click="resetForm('form')">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    import {refuse,cancelproject} from '@/api/admin/taskManagement'
    import { objKeySort } from '@/util/ajaxsign'
    export default {
        data() {
            return {
                dialogrefuse : false,
                title : '',
                form : {
                    content : ''
                },
                projectId : ''
            }
        },
        created() {},
       
        methods: {
            //设置展示
            setsataus(data,title){
                this.dialogrefuse = true;
                this.projectId = data;
                this.title = title;
            },
          
            //项目详情数据请求
            submitrefuse(data){
               if(this.title == "拒绝原因"){
                   this.refuse(data);
               }else{
                    this.cancel(data)
               }
            },

            //拒绝结项
            refuse(data){
                 this.$refs[data].validate((valid) => {
                    if (valid) {
                        refuse(objKeySort({projectId:this.projectId,content:this.form.content})).then(response =>{
                           this.resetForm('form');
                            this.$emit('refresh');
                        })
                    } else {
                        return false;
                    }
                });
            },

            //取消项目
            cancel(data){
                this.$refs[data].validate((valid) => {
                    if (valid) {
                        cancelproject(objKeySort({projectId:this.projectId,content:this.form.content})).then(response =>{
                           this.resetForm('form');
                            this.$emit('refresh');
                        })
                    } else {
                        return false;
                    }
                });
            },
            //取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.dialogrefuse = false;
            }
        }
    }
</script>